const WebIdIdentifiedInfoClosedKey = "WebIdIdentifiedInfoClosedKey";

// TODO: Document it
class WebIdIdentifiedInfoClosedStorage {

  constructor() {
  }

  store() {
    window.localStorage.setItem(WebIdIdentifiedInfoClosedKey, true);
  }

  clear() {
    window.localStorage.removeItem(WebIdIdentifiedInfoClosedKey);
  }

  get() {
    return Boolean(window.localStorage.getItem(WebIdIdentifiedInfoClosedKey));
  }
}

const instance = new WebIdIdentifiedInfoClosedStorage();
export default instance;